import React from "react";

import { isMobileDevice, isMobileMode, isServer } from "../../../utils";
import AARPAuthService from "../../services/AARPAuthService";
import { Button } from "../../atoms/Buttons/Base";
import { Fa } from "../../atoms/Icons/Fa";
import { Membership } from "../../atoms/Icons/MembershipIcon";
import { Text } from "../../atoms/Text/Text";
import styles from "./CoverBlock.css";
import { CoverItem, GetCoverByGame } from "../../constants/CustomCoverSettings";
import { GameState } from "../../models/Enums";
import { AARPAnalytics } from "../../services/Analytics/AARPAnalytics";
import classNames from "classnames";

type CoverBlockProps = {
  slug: string;
  gameName: string;
  gameState: GameState;
  onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isRewardVideoModal?: boolean;
};

export class CoverBlock extends React.Component<CoverBlockProps> {
  static displayName = "CoverBlock";
  state = {
    prefix: "",
  };

  onResize = () => {
    this.setState({
      prefix: isMobileMode() ? "This" : this.props.gameName,
    });
  };

  componentDidMount() {
    if (!isServer) {
      this.onResize();
      window.addEventListener("resize", this.onResize);
    }
  }

  componentWillUnmount() {
    if (!isServer) {
      window.removeEventListener("resize", this.onResize);
    }
  }

  GetDefaultCoverSettings(): CoverItem {
    const loginUrl = AARPAuthService.getNewLoginUrl(
      this.props.isRewardVideoModal
    );
    
    return this.props.gameState === GameState.COVER_MEMBER
      ? {
          ariaLabel: "membership join link",
          dataElementDescription: "membership message link",
          href: AARPAuthService.buildMemberJoinLink(
            this.props.isRewardVideoModal,
          ).href,
          header: <div>AARP Members only game</div>,
          title: <div>You're this close to getting so much more...</div>,
          text: (
            <div>
              Get access to this and all Members Only games plus a <br /> world
              of Member Benefits when you join AARP.
            </div>
          ),
          buttonText: "Become an AARP Member",
          smallText: (
            <div>
              <a
                data-categoryid="AARP Games"
                data-formelementid="GAMES-BTN-CLK-MEMBERSHIP-RENEW-MOIG_MODAL"
                href={loginUrl}
              >
                Already a member? Log in &gt;
              </a>
            </div>
          ),
          sign: <MemberSign size="coverLarge" />,
        }
      : {
          ariaLabel: "loging or register link",
          dataElementDescription: "loging or register message link",
          href: loginUrl,
          header: null,
          title: <div>Please log in to play {this.state.prefix}.</div>,
          text: <div>Log in or create a free account by clicking below.</div>,
          buttonText: "Get access now",
          smallText: null,
          sign: null,
        };
  }

  render() {
    const settings = GetCoverByGame(
      this.props.slug,
      this.GetDefaultCoverSettings()
    );
    const className =
      this.props.gameState === GameState.COVER_MEMBER
        ? classNames(styles.container, styles.membersOnly)
        : styles.container;

    return (
      <Overlay>
        <Container
          className={className}
          data-element-description="cover message"
        >
          <CloseButton
            aria-label="cover popup close button"
            onClick={this.props.onClose}
          >
            <Text size="xl">
              <Fa icon="times" aria-hidden="true" />
            </Text>
          </CloseButton>

          {settings.sign}
          <CoverHeaderInfo bold={true} size="h4" align="center">
            {settings.header}
          </CoverHeaderInfo>

          <CoverTitleInfo bold={true} size="h3" align="center">
            {settings.title}
          </CoverTitleInfo>

          <CoverTextInfo bold={false} size="lg" align="center">
            {settings.text}
          </CoverTextInfo>

          <GetInLink
            aria-label={settings.ariaLabel}
            data-element-description={settings.dataElementDescription}
            href={settings.href}
            {...(this.props.gameState === GameState.COVER_MEMBER &&
              AARPAnalytics.attr1Get())}
            {...(this.props.gameState === GameState.COVER_MEMBER &&
              AARPAnalytics.attrJoin())}
          >
            <Text bold={true} size="md">
              {settings.buttonText}
            </Text>
          </GetInLink>

          <CoverTextInfo bold={true} size="lg" align="center">
            {settings.smallText}
          </CoverTextInfo>
        </Container>
      </Overlay>
    );
  }
}

const Overlay = (props: any) => <div className={classNames(styles.memberOverlay, {[styles.modalPosition]: isMobileDevice()})} {...props} />;

const Container = (props: any) => (
  <div className={styles.container} {...props} />
);
const CoverHeaderInfo = (props: any) => (
  <Text className={styles.coverHeaderInfo} {...props} />
);
const CoverTextInfo = (props: any) => (
  <Text className={styles.coverTextInfo} {...props} />
);
const CoverTitleInfo = (props: any) => (
  <Text className={styles.coverTitleInfo} {...props} />
);
const GetInLink = (props: any) => <a className={styles.getInLink} {...props} />;
const MemberSign = (props: any) => (
  <Membership className={styles.memberSign} {...props} />
);
const CloseButton = (props: any) => (
  <Button className={styles.closeButton} {...props} />
);
